import { render, staticRenderFns } from "./ReviewStatements.vue?vue&type=template&id=0297a2ad&scoped=true&"
import script from "./ReviewStatements.vue?vue&type=script&lang=js&"
export * from "./ReviewStatements.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStatements.vue?vue&type=style&index=0&id=0297a2ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297a2ad",
  null
  
)

export default component.exports